const PATHS = {
  home: "/",
  contactUs: "/contact-us",
  aboutUs: "/about-us",
  terms: "/terms",
  privacyPolicy: "/privacy-policy",
  login:"/login",
  signUp:"/sign-up",
  services: "/services",
  pricing: "/pricing",
  faqs: "/faqs",
  basicInfo: "/basic-info",
  businessDetails: "/business-details",
  servicesNeeded: "/services-needed",
  clientScreening: "/client-screening",
  businessFormation: "/business-formation",
  additionalDetails: "/additional-details",
  businessAdvisory: "/business-advisory",
  businessSupport: "/business-support",
  stripe:"/stripe",
};

export default PATHS;